import * as React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { inputBaseClasses, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import Typography from '@mui/material/Typography';
import useId from '@mui/utils/useId';
import { OutlinedFieldMenu } from '@/components/OutlinedFieldMenu';
import VehicleSelectFilter from '@/components/Vehilces/VehicleFilters/VehicleSelectFilter';
export interface RangeTestProps {
  id?: string;
  label: string;
  minLabel: string;
  maxLabel: string;
  options: number[];
  value: [number, number];
  onChange: (idx: 0 | 1, val: number) => void;
  formatOption?: (val: number) => string;
  emptyLabel?: string;
}
const ClearIndicator = styled(IconButton, {
  name: 'TravviaVehicleSelectFilter',
  slot: 'ClearIndicator',
  overridesResolver: (_props, styles) => styles.clearIndicator
})({
  padding: 2,
  marginRight: -8,
  position: 'absolute',
  right: '35px',
  visibility: 'hidden'
});
export function VehicleRangeFilter({
  id,
  label,
  minLabel,
  maxLabel,
  options,
  value,
  onChange,
  formatOption,
  emptyLabel
}: RangeTestProps) {
  const elId = useId(id || 'vehicle-range-filter');
  const minElId = `${elId}-min`;
  const maxElId = `${elId}-max`;
  const [open, setOpen] = React.useState(false);
  function closeMenu() {
    setOpen(false);
  }
  function resetValues() {
    onChange(0, options[0]);
    onChange(1, options[options.length - 1]);
    closeMenu();
  }
  const hasValue = value[0] !== undefined && value[0] !== null && value[1] !== undefined && value[1] !== null && (value[0] !== options[0] || value[1] !== options[options.length - 1]);
  return <OutlinedFieldMenu id={elId} label={label} open={open} onOpen={() => {
    setOpen(true);
  }} onClose={() => {
    closeMenu();
  }} renderValue={() => {
    const minOpt = options[0];
    const maxOpt = options[options.length - 1];
    const isAll = (value[0] === undefined || value[0] === null || value[0] === minOpt) && (value[1] === undefined || value[1] === null || value[1] === maxOpt);
    const format = (v: number) => formatOption ? formatOption(v) : v;
    return isAll ? emptyLabel : `${format(value[0])} - ${format(value[1])}`;
  }} sx={{
    [`& .${inputBaseClasses.focused},:hover`]: {
      '& .clearIndicator': {
        visibility: 'visible'
      }
    }
  }} input={<OutlinedInput label={label} endAdornment={hasValue ? <ClearIndicator className="clearIndicator" onClick={() => {
    resetValues();
  }} size="small" edge="end">
                                <ClearIcon />
                            </ClearIndicator> : undefined} />}>
            <Typography sx={{
      mb: 2
    }}>{label}</Typography>
            <Grid container spacing={2}>
                <Grid size={6}>
                    <VehicleSelectFilter id={minElId} label={minLabel} options={options} value={value[0]} onChange={val => onChange(0, val)} formatOption={formatOption} showClearButton={false} />
                </Grid>
                <Grid size={6}>
                    <VehicleSelectFilter id={maxElId} label={maxLabel} options={options} value={value[1]} onChange={val_0 => onChange(1, val_0)} formatOption={formatOption} showClearButton={false} />
                </Grid>
            </Grid>
            <Box sx={{
      mt: 2,
      display: 'flex',
      justifyContent: 'space-between',
      gap: 2
    }}>
                <Button variant="outlined" onClick={resetValues}>
                    Clear
                </Button>
                <Button variant="contained" onClick={closeMenu}>
                    View Results
                </Button>
            </Box>
        </OutlinedFieldMenu>;
}